exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul li {\n  list-style: none; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/@core/component/add-widget/modal/widget.list.component.scss
// module id = ../../../../../src/app/@core/component/add-widget/modal/widget.list.component.scss
// module chunks = main